module.exports = "### 客户简介\r\n浙江华数广电网络股份有限公司以华数数字电视传媒集团有限公司为基础，省、市、县（市、区）广播电视播出机构共同参与、一体化运营组建，是浙江省级广播电视网络公司和省属国有股份制文化骨干企业。"